import { KEY } from '../types';
import { ActivityStatus } from './types';

export const SET_ACTIVITY_STATUS = `${KEY}.SET_ACTIVITY_STATUS`;
export const setActivityStatus = (activityStatus: ActivityStatus) => ({
  type: SET_ACTIVITY_STATUS,
  payload: activityStatus
});

export const SET_NEW_STARTED_FLOW_TIME_STAMP = `${KEY}.SET_NEW_STARTED_FLOW_TIME_STAMP`;
export const setNewStartedFlowTimeStamp = () => ({
  type: SET_NEW_STARTED_FLOW_TIME_STAMP
});
